import { createFileRoute } from '@tanstack/react-router'
import { object, optional, parse, string } from 'valibot'
import node, {
  type nexusAccountOverviewPageQuery,
} from '#gen/relay/nexusAccountOverviewPageQuery.graphql'
import { ErrorHandler } from '#lib/errors/errors'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

const SearchParamsSchema = object({
  filter: optional(string()),
})

export const Route = createFileRoute('/_dashboard/$account/nexus/')({
  staticData: { title: 'Nexus' },
  validateSearch(search) {
    return parse(SearchParamsSchema, search)
  },
  errorComponent: ErrorHandler,
  loader({ context, params }) {
    return context.preload<nexusAccountOverviewPageQuery>(node, {
      ...params,
    })
  },
  component: lazyLoadedComponent(
    () => import('#app/pages/nexus/nexus-account-overview-page'),
    'NexusAccountOverviewPage',
  ),
})
